import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';

const QuickLinksFragment = loadable(() =>
  import(/* webpackChunkName: "QuickLinksFragment" */ './QuickLinksFragment')
);
const RemoteModule = loadable(() =>
  import(/* webpackChunkName: "QuickLinksMF" */ '../../federation/RemoteModule')
);

export default function QuickLinks({
  isLoggedIn = false,
  moduleFederation,
  quicklinks,
  isDesktop,
  cdnHost
}) {
  if (typeof window === 'undefined' || !isLoggedIn) {
    return null;
  }

  //Note: need to add different configs based on env.
  const QuicklinksCDNConfig = {
    url: `https://${cdnHost}/test-bundles/mf-cdn-quicklinks/stable/mf-cdn-quicklinks.js`,
    scope: 'myRemoteCDNBundle',
    module: './QuicklinksCDN'
  };

  return moduleFederation ? (
    <section id="quicklinks-merchanthub-container">
      <RemoteModule
        config={QuicklinksCDNConfig}
        isDesktop={isDesktop}
        quicklinksData={quicklinks}
      />
    </section>
  ) : (
    <QuickLinksFragment />
  );
}

QuickLinks.propTypes = {
  isLoggedIn: PropTypes.bool,
  moduleFederation: PropTypes.bool,
  quicklinks: PropTypes.object,
  isDesktop: PropTypes.bool,
  cdnHost: PropTypes.string
};
